import { render, staticRenderFns } from "./ColumnsEdit.vue?vue&type=template&id=752297a7&scoped=true"
import script from "./ColumnsEdit.vue?vue&type=script&lang=ts"
export * from "./ColumnsEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752297a7",
  null
  
)

export default component.exports